module.exports = __webpack_public_path__ + "static/assets/be67df506c757cfb575aa160e6e342e8.svg";